<template>
    <div class="animated fadeIn">
        <filters :scope="filtersScope">
        </filters>
        <WebTabs></WebTabs>
        <StatisticTable :headColumns="headColumns"
                        :footColumns="footColumns"
                        :rows="rows"
                        :title="`${$t('pages.webmasters')}`"
                        @webGraph="webGraph"
                        @isPopup="isPopup">
            <template slot="table-actions">
                <button class="btn-close" @click="toggleExportHistoryModal()"><i class="fa fa-book"></i></button>
            </template>
        </StatisticTable>

        <modal large title="" v-model="exportHistiryModal" effect="fade/zoom">
                <div slot="modal-header" class="card-header" style="text-align: center">
                    <h4 class="modal-title" style="font-weight: 400;">История изменений</h4>
                </div>
            <div class="card-block statistic-table">
            <table class="table table-modal">
                <thead>
                <tr>
                    <th>Пользователь</th>
                    <th>Оффер</th>
                    <th>Вебмастер</th>
                    <th>Дата</th>
                    <th>Статус был</th>
                    <th>Статус стал</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="row in exportRows">
                    <td>{{row.user}}</td>
                    <td>{{row.offer}}</td>
                    <td>{{row.webmasters}}</td>
                    <td>{{row.date}}</td>
                    <td :class="getClassesModal(row.fix_from.status)">{{row.fix_from.text}}</td>
                    <td :class="getClassesModal(row.fix_to.status)">{{row.fix_to.text}}</td>
                </tr>
                </tbody>
            </table>
            </div>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-outline-info" @click="exportHistiryModal = false">
                    {{ $t('verbs.close') }}
                </button>
            </div>
        </modal>

        <modal large v-model="chartModal" effect="fade/zoom" v-if="webid">
          <div slot="modal-header" class="modal-header">
            <h4 class="modal-title">{{ chart.title }}</h4>
          </div>
          <div :id="`chart-container-${webid}`"></div>
          <div slot="modal-footer" class="modal-footer">
            <button type="button" class="btn btn-info" @click="chartModal = false"> {{ $t('verbs.close') }}</button>
          </div>
        </modal>

        <modal large v-model="webModal" effect="fade/zoom">
            <div slot="modal-header" class="modal-header">
                <h4 class="modal-title">Веб-мастер: {{ webid_modal }}</h4>
            </div>
            <div>
                <table class="table">
                    <thead>
                    <tr>
                        <th>Страны вебмастера</th>
                        <th>Проекты вебмастера</th>
                    </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in rowsReason" @click="getWebmastersRow(row)" :class="getClasses(row)">
                            <td>{{row.country.name}}</td>
                            <td>{{row.offer.name}}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div slot="modal-footer" class="modal-footer">
                <button type="button" class="btn btn-warning" @click="statusWebmasterFilter(statusFilter)"> {{ $t('verbs.statusFilter') }}</button>
                <button type="button" class="btn btn-danger" @click="statusWebmasterStop(statusStop)"> {{ $t('verbs.statusStop') }}</button>
                <button type="button" class="btn btn-info" @click="webModal = false"> {{ $t('verbs.close') }}</button>
            </div>
        </modal>
    </div>
</template>

<script>
  import Filters from '../../components/Filters.vue'
  import API from '../../api/API'
  import Storage from '../../api/Storage'
  import {find, map, orderBy} from 'lodash'
  import Helper from '../../api/Helper'
  import { modal } from 'vue-strap'
  import Highcharts from 'highcharts'
  import TypeColor from '../../assets/TypeColor'
  import StatisticTable from '../../components/StatisticTable.vue'
  import WebTabs from './WebTabs'
  import getSymbolFromCurrency from 'currency-symbol-map'

export default {
    name: 'Webmasters',
    components: {
      WebTabs,
      modal,
      Filters,
      StatisticTable
    },
    data () {
      return {
        statusStop: 1,
        statusFilter: 2,
        filtersScope: {
          dateFilter: true,
          offerFilter: true,
          byWmFilter: true
        },
        chartModal: false,
        webModal: false,
        isLoading: false,
        Storage: Storage,
        TypeColor: TypeColor,
        Helper: Helper,
        country: null,
        webid: null,
        webid_modal: '',
        headColumns: [
          {label: this.$root.$t('statistic.webmaster'), field: 'webmaster'},
          {label: this.$root.$t('statistic.proportion'), field: 'proportion'},
          {label: this.$root.$t('statistic.total'), field: 'total'},
          {label: this.$root.$t('statistic.processed'), field: 'processed', colspan: 2},
          {label: this.$root.$t('statistic.accepted'), field: 'accepted', colspan: 2},
          {label: this.$root.$t('statistic.paid'), field: 'paid', colspan: 2},
          {label: this.$root.$t('statistic.return'), field: 'return', colspan: 2},
          {label: this.$root.$t('statistic.averageBill'), field: 'averageBill', colspan: 2},
          {label: this.$root.$t('statistic.averageBuyback'), field: 'averageBuyback', colspan: 2},
          {label: this.$root.$t('statistic.canceled'), field: 'canceled', colspan: 2},
          {label: this.$root.$t('statistic.error'), field: 'error', colspan: 2},
          {label: this.$root.$t('statistic.approvedFromValid'), field: 'approvedFromValid', width: '80px'},
          { label: this.$root.$t('statistic.ad_approved'), field: 'ad_approved' },
          { label: this.$root.$t('statistic.ad_pre_approved'), field: 'ad_pre_approved' },
          { label: this.$root.$t('statistic.ad_difference'), field: 'ad_difference' },
          { label: this.$root.$t('statistic.ad_approve_percent'), field: 'approve_percent' }
        ],
        headColumnsReason: [
          {label: this.$root.$t('statistic.country_id_web'), field: 'country_id'},
          {label: this.$root.$t('statistic.offer_id_web'), field: 'offer_id'}
        ],
        rowsReason: [],
        rows: [],
        footColumns: {},
        chart: {
          isBuilded: false,
          isHidden: false,
          title: {
            text: null
          },
          subtitle: {
            text: null
          },
          credits: {
            enabled: false
          },
          yAxis: [{ // --- Primary yAxis
            title: {
              text: null
            },
            tickInterval: 1
          }],
          tooltip: {
            valueSuffix: null
          },
          xAxis: {
            type: 'datetime',
            labels: {
              format: '{value:%Y-%m-%d}'
            }
          },
          series: []
        },
        statusForWebmasters: [],
        exportHistiryModal: false,
        exportRows: []
      }
    },
    mounted () {
      this.calculateRows()
      this.$root.$on('filters_load_new_data', () => {
        this.calculateRows()
      })
    },
    methods: {
      calculateRows () {
        this.$root.$emit('data_loading')
        this.rows = []
        this.footColumns = {}
        let oldArrCurrency = []
        let newArrCurrency = []
        API.getWebmasterStatistic().then(response => {
          let sumTotal = 0
          const count = Object(response.data).keys.length
            // парсим тотал (для доли)
          map(response.data, (d) => {
            sumTotal += parseInt(d.total)
          })
          map(response.data, d => {
            oldArrCurrency.push(d.local_currency.split(','))
            oldArrCurrency.forEach(array => {
              array.forEach(item => {
                newArrCurrency.push(item)
              })
            })
          })
          let filterCurrency = newArrCurrency.filter((item, index) => {
            return newArrCurrency.indexOf(item) === index
          })
            // и все остальное
          let sumProcessed = 0
          let countProcessed = 0
          let sumApproved = 0
          let countApproved = 0
          let sumCanceled = 0
          let countCanceled = 0
          let sumError = 0
          let countError = 0
          let sumPaid = 0
          let countPaid = 0
          let sumReturn = 0
          let countReturn = 0
          let sumAverageBillLocal = 0.0
          let sumAverageBuybackLocal = 0.0
          let sumAverageBill = 0.0
          let sumAverageBuyback = 0.0
          let sumAdApproved = 0
          let sumAdPreApproved = 0
          let sumAdDifference = 0
          let sumApprovePercent = 0
          map(response.data, (d) => {
            if (d.processed > 0) {
              sumProcessed += parseInt(d.processed)
              countProcessed++
            }
            if (d.approved > 0) {
              sumApproved += parseInt(d.approved)
              countApproved++
              sumAverageBill += parseFloat(d.average_bill_usd) * d.approved
              sumAverageBillLocal += parseFloat(d.average_bill_local) * d.approved
              sumAverageBuyback += parseFloat(d.average_buyout_usd) * d.paid
              sumAverageBuybackLocal += parseFloat(d.average_buyout_local)
              this.localCurrencySymbol = getSymbolFromCurrency(d.local_currency)
            }
            if (d.canceled > 0) {
              sumCanceled += parseInt(d.canceled)
              countCanceled++
            }
            if (d.error > 0) {
              sumError += parseInt(d.error)
              countError++
            }
            if (d.paid > 0) {
              sumPaid += parseInt(d.paid)
              countPaid++
            }
            if (d.return > 0) {
              sumReturn += parseInt(d.return)
              countReturn++
            }
            if (d.ad_approved > 0) {
              sumAdApproved += parseInt(d.ad_approved)
            }
            if (d.ad_pre_approved > 0) {
              sumAdPreApproved += parseInt(d.ad_pre_approved)
            }
            if (d.approve_percent < 0) {
              sumApprovePercent += parseInt(d.approve_percent)
            }

            sumAdDifference += isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : d.ad_approved - d.ad_pre_approved

            this.rows.push({
              webmaster: {
                isCollspaned: true,
                value: d.wm_id,
                is_new: d.is_new,
                popup: true,
                statusFilter: d.count_filter,
                statusStop: d.count_stop
              },
              proportion: {
                value: Helper.percents(sumTotal, d.total),
                bgg: Helper.renderSingleGist(parseInt(d.total), parseInt(d.canceled)),
                ocb: (value) => {
                  return Helper.getRawNumber(value)
                }
              },
              total: {
                value: d.total,
                bg: true,
                webGraph: true,
                wb: d.wm_id
              },
              processed: {
                value: d.processed,
                bgg: Helper.renderGistPart(d.total, d.processed),
                isCollspaned: true
              },
              processedPercents: {
                value: Helper.percents(d.total, d.processed),
                bgg: Helper.renderGistPart(d.total, d.processed, true)
              },
              accepted: {
                value: d.approved,
                bgg: Helper.renderGistPart(d.total, d.approved),
                isCollspaned: true
              },
              acceptedPercents: {
                value: Helper.percents(d.total, d.approved),
                bgg: Helper.renderGistPart(d.total, d.approved, true),
                webGraph: true,
                wb: d.wm_id,
                webGraphSymbol: '%'
              },
              paid: {
                value: d.paid,
                bgg: Helper.renderGistPart(d.approved, d.paid),
                isCollspaned: true
              },
              paidPercents: {
                value: Helper.percents(parseInt(d.approved), parseInt(d.paid)),
                bgg: Helper.renderGistPart(d.approved, d.paid, true),
                webGraph: true,
                wb: d.wm_id,
                webGraphSymbol: '%'
              },
              return: {
                value: d.return,
                bgg: Helper.renderGistPart(d.approved, d.return),
                isCollspaned: true
              },
              returnPercents: {
                value: Helper.percents(parseInt(d.approved), parseInt(d.return)),
                bgg: Helper.renderGistPart(d.approved, d.return, true)
              },
              averageBill: {
                value: '$ ' + d.average_bill_usd.toFixed(2),
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_bill, nch, true)),
                isCollspaned: true
              },
              averageBillLocal: {
                value: d.local_currency.split(',').length === 1 ? `${d.average_bill_local.toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                  // value: Helper.localAverageBill(d.average_buyout),
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_buyout, nch, true), true)
              },
              averageBuyback: {
                value: '$ ' + d.average_buyout_usd.toFixed(2),
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_buyout, nch, true)),
                isCollspaned: true
              },
              averageBuybackLocal: {
                value: d.local_currency.split(',').length === 1 ? `${d.average_buyout_local.toFixed(0)} ${getSymbolFromCurrency(d.local_currency)}` : '-'
                  // bgg: Helper.renderGistPart(100, Helper.averageBillDay(d.average_buyout, nch, true), true)
              },
              canceled: {
                value: d.canceled,
                bgg: Helper.renderGistPart(d.total, d.canceled),
                isCollspaned: true
              },
              canceledPercents: {
                value: Helper.percents(parseInt(d.total), parseInt(d.canceled)),
                bgg: Helper.renderGistPart(d.total, d.canceled, true)
              },
              error: {
                value: d.error,
                bgg: Helper.renderGistPart(d.total, d.error),
                isCollspaned: true
              },
              errorPercents: {
                value: Helper.percents(parseInt(d.total), parseInt(d.error)),
                bgg: Helper.renderGistPart(d.total, d.error, true)
              },
              approvedFromValid: {
                value: `${(d.approved_from_valid).toFixed(1)}%`
              },
              ad_approved: {
                value: d.ad_approved ? Number(d.ad_approved.toFixed(2)) : 0
              },
              ad_pre_approved: {
                value: d.ad_pre_approved ? Number(d.ad_pre_approved.toFixed(2)) : 0
              },
              ad_difference: {
                value: isNaN(d.ad_approved - d.ad_pre_approved) ? 0 : Number((d.ad_approved - d.ad_pre_approved).toFixed(2))
              },
              approve_percent: {
                value: d.approve_percent
              }
            })
          })
          this.footColumns = {
            label: {
              value: this.$root.$t('statistic.in_total')
            },
            proportion: {
              value: null
            },
            total: {
              value: `${sumTotal}`
            },
            processed: {
              value: `${sumProcessed}`
            },
            processedPercents: {
              value: Helper.percents(sumTotal, sumProcessed)
            },
            accepted: {
              value: `${sumApproved}`
            },
            acceptedPercents: {
              value: Helper.percents(sumTotal, sumApproved)
            },
            paid: {
              value: `${sumPaid}`
            },
            paidPercents: {
              value: Helper.percents(sumApproved, sumPaid)
            },
            return: {
              value: `${sumReturn}`
            },
            returnPercents: {
              value: Helper.percents(sumApproved, sumReturn)
            },
            averageBill: {
              value: Helper.averageBillDayCount(sumAverageBill, sumApproved),
              graph: {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: '$'
              }
            },
            averageBillLocal: {
              value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBillLocal, sumApproved, this.localCurrencySymbol) : '-',
              graph: filterCurrency.length === 1 ? {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: this.localCurrencySymbol
              } : false
            },
            averageBuyback: {
              value: Helper.averageBillDayCount(sumAverageBuyback, sumPaid),
              graph: {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: '$'
              }
            },
            averageBuybackLocal: {
              // value: filterCurrency.length === 1 ? Helper.newLocalAverageBill(sumAverageBuybackLocal, sumApproved, this.localCurrencySymbol) : '-',
              value: filterCurrency.length === 1
                ? Helper.newLocalAverageBill(sumAverageBuybackLocal, this.rows.filter(row => Number(row.averageBuybackLocal.value.split(' ')[0])).length, this.localCurrencySymbol)
                : '-',
              graph: filterCurrency.length === 1 ? {
                cb: (value) => {
                  return Helper.getRawNumber(value)
                },
                symbol: this.localCurrencySymbol
              } : false
            },
            canceled: {
              value: `${sumCanceled} (${Helper.average(sumCanceled, countCanceled)})`
            },
            canceledPercents: {
              value: Helper.percents(sumTotal, sumCanceled)
            },
            error: {
              value: `${sumError} (${Helper.average(sumError, countError)})`
            },
            errorPercents: {
              value: Helper.percents(sumTotal, sumError)
            },
            approvedFromValid: {
              value: Helper.approvedFromValid(sumApproved, sumTotal, sumError)
            },
            ad_approved: {
              value: sumAdApproved
            },
            ad_pre_approved: {
              value: sumAdPreApproved
            },
            ad_difference: {
              value: sumAdDifference
            },
            approve_percent: {
              value: sumApprovePercent
            }
          }
          this.$root.$emit('data_loaded')
        }).catch(response => {
          this.$root.$emit('data_loaded')
          console.log(response)
          this.$notify({
            type: 'danger',
            title: this.$root.$t('verbs.error'),
            text: response,
            animationType: 'velocity'
          })
        })
      },
      webGraph (cell, i) {
        let name = (i === 'acceptedPercents') ? 'approved' : (i === 'paidPercents') ? 'paid' : 'total'
        this.webid = cell.wb
        let approvedAll = []
        let acceptedPercentsName = this.$root.$t(`statistic.approved`)
        let totalPercentsTotal = this.$root.$t(`statistic.total`)
        let totals = this.$root.$t(`verbs.total`)
        API.getWebmastersGraphs(cell.wb).then(response => {
          const rows = orderBy(response.body, [function (item) {
            return item.date.value
          }], ['asc'])
          let series = []
          map(rows, (row) => {
            let value = (i === 'acceptedPercents') ? Helper.percentsF(row['total'], row['approved']) : (i === 'paidPercents') ? Helper.percentsF(row['approved'], row['paid']) : row['total']
            approvedAll[Date.parse(row.date)] = row['approved']
            series.push([Date.parse(row.date), value])
          })
          if (cell.webGraphSymbol) {
            this.chart.tooltip.valueSuffix = cell.webGraphSymbol
          } else {
            this.chart.tooltip.valueSuffix = null
          }
          this.chart.title = this.$root.$t(`statistic.${name}`)
          this.chart.series[0] = {
            data: series,
            color: TypeColor[i],
            name: this.$root.$t(`statistic.${name}`)
          }
          this.chart.yAxis[0].min = 0
          this.chart.yAxis[0].title.text = this.$root.$t(`statistic.${name}`)
          this.chart.tooltip.formatter = function () {
            if (this.series.name === acceptedPercentsName) {
              return `${this.series.name}: <b>${this.point.y} %</b><br>${totals}: <b>${approvedAll[this.x]}</b>`
            } else if (this.series.name === totalPercentsTotal) {
              return `${this.series.name}: <b>${this.point.y} </b>`
            } else {
              return `${this.series.name}: <b>${this.point.y} %</b>`
            }
          }
          Highcharts.chart(`chart-container-${this.webid}`, this.chart)
          this.chartModal = true
        })
      },
      getApiOffers (countries, offer) {
        return new Promise(function (resolve, reject) {
          let offerTitle = []
          API.getOffers(countries).then(response => {
            map(response.body, (data) => {
              if (parseInt(offer) === data.id) {
                offerTitle.push(data.title)
                resolve(offerTitle)
              }
            })
          }).catch(error => {
            reject(error)
          })
        })
      },
      isPopup (cell) {
        this.rowsReason = []
        this.webid_modal = cell.value
        this.statusForWebmasters = []
        API.getWebPopup(cell.value)
          .then(response => {
            map(response.data, (d) => {
              const country = find(Storage.countries, {id: parseInt(d.country_id)})
              this.getApiOffers(d.country_id, d.offer_id).then(response => {
                response.forEach(item => {
                  this.rowsReason.push({
                    wm_id: cell.value,
                    country: {country_id: d.country_id, name: country.name},
                    offer: {offer_id: d.offer_id, name: item},
                    status: d.status,
                    active: false
                  })
                })
              })
            })
          }).catch(error => {
            console.log(error)
          })
        this.webModal = true
      },
      getClasses (row) {
        let classes = []
        let status = parseInt(row.status)
        if (status === 1) {
          classes.push('stop')
        }
        if (status === 2) {
          classes.push('filter')
        }
        if (row.active) {
          classes.push('active')
        }
        return classes
      },
      getWebmastersRow (row) {
        if (row.active) {
          row.active = false
        } else {
          row.active = true
        }
        this.statusForWebmasters.push(row)
      },
      statusWebmasterFilter (status) {
        this.statusForWebmasters.forEach(item => {
          if (status === parseInt(item.status)) {
            API.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, 0)
          } else {
            API.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, status)
          }
        })
        this.webModal = false
        this.calculateRows()
      },
      statusWebmasterStop (status) {
        this.statusForWebmasters.forEach(item => {
          if (status === parseInt(item.status)) {
            API.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, 0)
          } else {
            API.webmasterStatus(item.wm_id, item.country.country_id, item.offer.offer_id, status)
          }
        })
        this.webModal = false
        this.calculateRows()
      },
      toggleExportHistoryModal () {
        this.exportRows = []
        API.historyWebmasterStatus().then(response => {
          const returnStatusText = (status) => {
            if (+status === 1) {
              return 'Стоп'
            }
            if (+status === 2) {
              return 'Фильтр'
            }
            if (+status === 0) {
              return 'По умолчанию'
            }
          }
          map(response.body, (d) => {
            this.exportRows.push({
              user: d.username,
              offer: d.offer,
              webmasters: d.webmaster_id,
              date: d.datetime,
              fix_from: {text: returnStatusText(d.status_from), status: d.status_from},
              fix_to: {text: returnStatusText(d.status_to), status: d.status_to}
            })
          })
        })
        this.exportHistiryModal = true
      },
      getClassesModal (row) {
        let classes = []
        if (+row === 1) {
          classes.push('stop')
        }
        if (+row === 2) {
          classes.push('filter')
        }
        if (+row === 0) {
          classes.push('default')
        }
        return classes
      }
    }
  }
</script>
<style scoped>
    .table tr.stop {
        background-color: rgb(239, 154, 154);
    }
    .table tr.filter {
        background-color: rgb(255, 249, 196);
    }
    .table tr.active {
        background-color: rgb(185, 246, 202);
    }
    .table tbody tr {
        cursor: pointer;
    }
    .table-modal td.stop {
        background-color: rgb(239, 154, 154);
    }
    .table-modal td.filter {
        background-color: rgb(255, 249, 196);
    }
    .table-modal td.default {
        background-color: #fff;
    }
 </style>



// WEBPACK FOOTER //
// Webmasters.vue?57553c74